<div class="only-header-section-page">
    <header class="red-to-purlpe-gradient">
        <div class="container">
            <div class="row text-center">
                <div class="col-lg-12">
                    <h1>{{headerText}}</h1>
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <p><span [translate]="'forbidden_page.text'"></span></p>
                </div>
            </div>
        </div>
    </header>
</div>
